import React from "react";
import { FaExternalLinkAlt, FaFolderOpen } from "react-icons/fa";

/** A row of Drive folders at the top of a Pilots tab. */
export function ResourceLinks({ title, links }) {
  return (
    <nav className="pl-resources" aria-label={title}>
      <span className="pl-resources-title">
        <FaFolderOpen aria-hidden="true" /> {title}
      </span>
      {links.map((link) => (
        <a
          key={link.key}
          className="pl-resource"
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.label} <FaExternalLinkAlt aria-hidden="true" />
        </a>
      ))}
    </nav>
  );
}
